// extracted by mini-css-extract-plugin
module.exports = {"list":"_1p_zQ"};